import URIS from 'constants/uris';
import http from 'services/http';

getLegalTypes.operation = 'READ';
getLegalTypes.idFrom = 'ARGS';
export function getLegalTypes(params) {
  return http.get(`${URIS.LEGAL_TYPES}`, { params });
}
